import { createApiClient } from "./client";
import { publicEnv } from "../env";
import { getCurrentLocale } from "@/i18n/config";

/** 浏览器共享的 FC API 客户端，由浏览器随请求发送 HttpOnly 会话 Cookie。 */
export const apiClient = createApiClient({
  baseUrl: publicEnv.apiUrl,
  getLocale: getCurrentLocale,
});
